// Labels compactos para chips de período/comparativa.
// El label "largo" (Mes anterior vs Mismo período del año anterior) ocupa demasiado.
// Cuando la fila tiene muchas comparativas, conviene usar el formato corto + tooltip.

import {
    PERIOD_TODAY, PERIOD_YESTERDAY, PERIOD_THIS_WEEK, PERIOD_LAST_WEEK,
    PERIOD_LAST_7_DAYS, PERIOD_LAST_14_DAYS, PERIOD_LAST_30_DAYS,
    PERIOD_THIS_MONTH, PERIOD_THIS_MONTH_TILL_YESTERDAY, PERIOD_LAST_MONTH,
    PERIOD_THIS_PERIOD, PERIOD_THIS_PERIOD_TILL_YESTERDAY,
    PERIOD_LAST_3_MONTHS, PERIOD_LAST_6_MONTHS,
    PERIOD_7_DAYS_BEFORE, PERIOD_14_DAYS_BEFORE,
    PERIOD_PREVIOUS_PERIOD, PERIOD_LAST_YEAR, PERIOD_SAME_PERIOD_LAST_YEAR,
    NO_COMPARATION_PERIOD, getPeriodsData,
} from "./columns";

const SHORT_PERIOD = {
    [PERIOD_TODAY]: 'Hoy',
    [PERIOD_YESTERDAY]: 'Ayer',
    [PERIOD_THIS_WEEK]: 'Esta sem.',
    [PERIOD_LAST_WEEK]: 'Sem. ant.',
    [PERIOD_LAST_7_DAYS]: 'Últ. 7d',
    [PERIOD_LAST_14_DAYS]: 'Últ. 14d',
    [PERIOD_LAST_30_DAYS]: 'Últ. 30d',
    [PERIOD_THIS_MONTH]: 'Este mes',
    [PERIOD_THIS_MONTH_TILL_YESTERDAY]: 'Mes (a ayer)',
    [PERIOD_LAST_MONTH]: 'Mes ant.',
    [PERIOD_THIS_PERIOD]: 'Este período',
    [PERIOD_THIS_PERIOD_TILL_YESTERDAY]: 'Per. (a ayer)',
    [PERIOD_LAST_3_MONTHS]: 'Últ. 3m',
    [PERIOD_LAST_6_MONTHS]: 'Últ. 6m',
    [PERIOD_7_DAYS_BEFORE]: '7d ant.',
    [PERIOD_14_DAYS_BEFORE]: '14d ant.',
    [PERIOD_PREVIOUS_PERIOD]: 'Per. ant.',
    [PERIOD_LAST_YEAR]: 'Año ant.',
    [PERIOD_SAME_PERIOD_LAST_YEAR]: 'YoY',
};

// Devuelve {short, full} para mostrar un chip compacto con tooltip.
// short: 1-2 palabras (cabe holgado en chip). full: label completo i18n.
export function compactPeriodLabel(t, mainPeriod, vsPeriod) {
    const long = getPeriodsData(t);
    const fullMain = long[mainPeriod] || mainPeriod;
    if (!vsPeriod || vsPeriod === NO_COMPARATION_PERIOD) {
        return {short: SHORT_PERIOD[mainPeriod] || fullMain, full: fullMain};
    }
    const fullVs = long[vsPeriod] || vsPeriod;
    const shortMain = SHORT_PERIOD[mainPeriod] || fullMain;
    const shortVs = SHORT_PERIOD[vsPeriod] || fullVs;
    return {
        short: `${shortMain} vs ${shortVs}`,
        full: `${fullMain} vs ${fullVs}`,
    };
}
